import { useRouter } from "next/router";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const TopHeaderSwiper = ({ headerJson }) => {
  const activeData = headerJson?.find(
    (item) => item?.active && item?.key === "text-slider"
  );
  const { locale } = useRouter();

  const ads = activeData?.value;

  return (
    <Swiper
      modules={[Autoplay]}
      autoplay={{ delay: 2500, disableOnInteraction: false }}
      direction="vertical"
      slidesPerView={1}
      loop={ads?.length > 1}
      className="text-center top-header-swiper sm:text-base sm:mt-1"
      spaceBetween={10}
    >
      {ads?.map((el, i) => (
        <SwiperSlide key={i} className="max-sm:text-xs text-sm">
          <p className="text-nowrap">{el?.[`title-${locale}`]}</p>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default TopHeaderSwiper;
